<template>
  <div class="aha-footer">
    <template v-if="isPoweredByShowing && !isCtaShowing">
      <div class="powered-by">
        <a
          :href="poweredByURL"
          target="_blank"
          class="mr-2"
          @click="trackPoweredByGAEvent"
        >{{ $t("powerBy") }}</a>
        <a :href="termsURL" target="_blank" @click="trackTermsGAEvent">{{ $t("term") }}</a>
      </div>
    </template>
    <a
      v-if="isCtaShowing"
      tabindex="0"
      class="audience-cta-wrapper"
      @click="handleAudienceCtaClick"
      :href="footerBannerURL"
      target="_blank"
    >
      <div class="audience-cta">
        <div class="audience-cta__hero-image-wrapper">
          <img
            class="audience-cta__hero-image"
            src="@/assets/images/Clap.svg"
            alt="Thank you for your participation"
          >
          <img
            class="audience-cta__hero-image-fireworks"
            src="@/assets/images/Clap-hover-fireworks.svg"
            alt="Thank you for your participation"
          >
        </div>
        <span class="audience-cta__description">
          {{ $t('enjoyThisPresentationFooterBanner') }}
          <div>
            <div class="audience-cta__link">
              <span class="audience-cta__link-text">{{ $t('letsGoFooterBanner') }}</span>
              <AhaSvg
                name="arrow-no-tail"
                view-box="0 0 8 14"
              />
            </div>
          </div>
        </span>
      </div>
    </a>
  </div>
</template>

<script>
// components
import AhaSvg from 'storybook-presenter/UI/Svg'

export default {
  components: {
    AhaSvg,
  },
  props: {
    isCtaShowing: {
      type: Boolean,
      default: false,
    },
    isPoweredByShowing: {
      type: Boolean,
      default: false,
    },
    poweredByURL: {
      type: String,
      default: '',
    },
    termsURL: {
      type: String,
      default: '',
    },
    footerBannerURL: {
      type: String,
      default: '',
    },
    trackTermsGAEvent: {
      type: Function,
      default: () => {},
    },
    trackPoweredByGAEvent: {
      type: Function,
      default: () => {},
    },
    handleAudienceCtaClick: {
      type: Function,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.aha-footer {
  width: 100%;
  box-sizing: border-box;
}

.powered-by {
  display: flex;
  justify-content: center;
  padding: 12px;

  a {
    text-decoration: none;
  }
}

.audience-cta-wrapper {
  -webkit-user-select: none;  /* Chrome all / Safari all */
  -moz-user-select: none;     /* Firefox all */
  -ms-user-select: none;      /* IE 10+ */
  user-select: none;          /* Likely future */
  text-decoration: none;
}

.audience-cta {
  display: flex;
  background: #FFFFFF;
  padding: 12px;
  width: 100%;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.08);
  cursor: pointer;
    &:hover, &:focus, &:active {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.03);
    .audience-cta__link {
      color: #257ADC;
    }
    .audience-cta__hero-image-fireworks {
      opacity: 1;
    }
  }
}

.audience-cta__description {
  color: #4B4B4B;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  margin: 0 0 8px;
}

.audience-cta__link {
  font-size: 14px;
  line-height: 14px;
  color: #348EF6;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}

.audience-cta__hero-image-wrapper {
  position: relative;
  .audience-cta__hero-image {
    margin: 0 8px 0 0;
    display: inline-block;
    height: 65px;
    width: 65px;
  }
  .audience-cta__hero-image-fireworks {
    opacity: 0;
    position: absolute;
    top: -21px;
    left: -7px;
    width: 75px;
    height: 75px;
  }
}

</style>
